import { useCriteriaFieldPath } from './useCriteriaFieldPath';

export const useCriteriaCombinatorFieldPath = () => {
  const criteria = useCriteriaFieldPath();
  return `${criteria}.combinator` as const;
};
